import React from 'react';
import PropTypes from 'prop-types';

const HexColorPicker = ({ name = '', value = '', changeHandler = () => {} }) => {
    const colorDisplayMSBoxName = `${name}--color-ms`;
    const colorDisplayBoxName = `${name}-color-display`;

    const onChange = (e) => {
        e.preventDefault();
        changeHandler(e);
    };

    return (
        <div>
            <div className="tv-hex-input">
                <div className="tv-hex-input__input-wrapper">
                    <input id={name} type="text" className="text-uppercase" placeholder="#FFF000" value={value} maxLength="7" onChange={onChange} />
                    <div id={colorDisplayMSBoxName} type="color" className="tv-hex-input__display" style={{ backgroundColor: { value } }} />
                    <input id={colorDisplayBoxName} type="color" value={value || '#FFFFFF'} className="tv-hex-input__display" style={{ backgroundColor: { value } }} onChange={onChange} aria-label={colorDisplayBoxName} />
                </div>
            </div>
        </div>
    );
};


HexColorPicker.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    changeHandler: PropTypes.func.isRequired,
};

export default HexColorPicker;
